"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpTimeoutError = void 0;
var genericError_1 = require("./genericError");
var HttpTimeoutError = /** @class */ (function (_super) {
    __extends(HttpTimeoutError, _super);
    function HttpTimeoutError(message, domain) {
        if (domain === void 0) { domain = 'httpApi'; }
        var _this = _super.call(this, { type: 'TimeoutError', domain: domain, message: message }) || this;
        Object.setPrototypeOf(_this, HttpTimeoutError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, HttpTimeoutError);
        }
        else {
            _this.stack = new Error().stack;
        }
        return _this;
    }
    return HttpTimeoutError;
}(genericError_1.GenericError));
exports.HttpTimeoutError = HttpTimeoutError;
//# sourceMappingURL=httpTimeoutError.js.map